import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TranslateContext} from "../../context/TranslateContext";
import {getFrequenzeApi, rimuoviFrequenzaApi} from "./services/FrequenzeServices";
import ConfFrequenzeView from "./ConfFrequenzeView";

export default function ConfFrequenzeController() {

    const [loadingData, setLoadingData] = useState(true);

    const [frequenze, setFrequenze] = useState([]);
    const [frequenzaSel, setFrequenzaSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getFrequenze() {
        const response = await getFrequenzeApi();
        setFrequenze(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getFrequenze();
    }, []);

    const eliminaFrequenza = async () => {
        setShowConfirm(false);
        const response = await rimuoviFrequenzaApi(frequenzaSel.id_frequenza_compilazione);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setFrequenze(response.data.data);
        }
    }

    const bottoniDx = [
        {
            label: translate("Aggiungi Frequenza"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-frequenza-comp");
            }
        }
    ];

    function onClickElimina(row) {
        setFrequenzaSel(row)
        setShowConfirm(true);
    }

    function onRowDbClickFrequenza(row) {
        history.push("/upd-frequenza-comp/" + row.id_frequenza_compilazione);
    }

    return (
        !loadingData &&
        <ConfFrequenzeView
            setShow={setShow}
            translate={translate}
            showConfirm={showConfirm}
            show={show}
            setShowConfirm={setShowConfirm}
            modalMsg={modalMsg}
            frequenze={frequenze}
            frequenzaSel={frequenzaSel}
            eliminaFrequenza={eliminaFrequenza}
            bottoniDx={bottoniDx}
            onClickElimina={onClickElimina}
            onRowDbClickFrequenza={onRowDbClickFrequenza}
        />
    );
}
